// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WWba","col":"styles_col__1Lfj_"};